import { Component, OnInit, Input, Output, EventEmitter, OnChanges, HostListener, ViewChild, ElementRef, AfterContentInit,AfterViewInit, ChangeDetectorRef  } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { TermModel } from '../../../_models/_index';
import { GeneralService, TermService } from '../../../services/_index';
import { DealStepEnum, ViewModeEnum, AlertDialogTypeEnum } from '../../../_enums/_index';
import { AlertDialogComponent } from '../../alert-dialog/alert-dialog.component';
import { TermDialogComponent } from '../term-dialog/term-dialog.component';

@Component({
  selector: 'app-terms-grid',
  templateUrl: './terms-grid.component.html',
  styleUrls: ['./terms-grid.component.css']
})
export class TermsGridComponent implements OnInit,AfterViewInit {
    scrollHeight: string = "490px";
    terms: TermModel[];

    constructor(private termService: TermService,
        private dialog: MatDialog,
        private cdRef: ChangeDetectorRef,
        private generalService: GeneralService) {
        this.terms = [];
    }

    //@HostListener('window:resize', ['$event'])
    //onResize(event) {
    //    this.scrollHeight = window.innerHeight  + "px";
    //    this.cdRef.detectChanges();
    //    console.log(this.scrollHeight);
    //}

    @ViewChild('divPDT') el: ElementRef;


    ngOnInit() {
        this.loadData();
    }

 

    ngAfterViewInit()
    {
                

        //this.scrollHeight = "250" + "px";
        //this.cdRef.detectChanges();  
        //console.log(this.scrollHeight);
    }

    loadData() {
        this.termService.getTerms().then(result => {
            this.terms = result;
        });
    }

    openAddDialog() {
        let dialogRef = this.dialog.open(TermDialogComponent);
        dialogRef.disableClose = true;
        dialogRef.componentInstance.dialogHeader = 'הוספת תנאי';
        dialogRef.componentInstance.viewMode = ViewModeEnum.Add;

        dialogRef.afterClosed().subscribe((result: TermModel) => {
            if (result) {
                result;
                let copy = Object.assign([], this.terms);
                copy.push(result);
                this.terms = copy;
                this.generalService.showSnackBar("הוספת תנאי התבצעה בהצלחה!");
            }
        });
    }

    openEditDialog(model: TermModel) {
        let dialogRef = this.dialog.open(TermDialogComponent);
        dialogRef.disableClose = true;
        dialogRef.componentInstance.dialogHeader = 'עריכת תנאי';
        dialogRef.componentInstance.viewMode = ViewModeEnum.Edit;
        let model2edit: TermModel = new TermModel();
        model2edit = Object.assign({}, <TermModel>model);
        dialogRef.componentInstance.term = model2edit;

        dialogRef.afterClosed().subscribe((result: TermModel) => {
            if (result) {
                let copy = Object.assign([], this.terms);
                copy.splice(this.terms.findIndex(o => o.id == result.id), 1, result);
                this.terms = copy;
                this.generalService.showSnackBar("עריכת תנאי התבצעה בהצלחה!");
            }
        });
    }

    removeServiceItem(model: TermModel) {
        let message = "האם אתה בטוח שברצונך למחוק תנאי " + model.description + "?";
        this.generalService.showConfirmDialog(message).then(result => {
            if (result) {
                this.termService.removeTerm(model).then(res => {
                    if (res) {
                        let copy = Object.assign([], this.terms);
                        copy.splice(this.terms.findIndex(o => o.id == model.id), 1);
                        this.terms = copy;
                        this.generalService.showSnackBar("תנאי הוסר בהצלחה!");
                    }
                });
            }
            else {
                this.generalService.showSnackBar("מחיקה בוטלה");
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/components/terms/terms-grid/terms-grid.component.ts